import React from 'react';
import DOMPurify from 'dompurify';
import PrintFunctions from '../Print/PrintFunctions';
import './styles.scss';

const selectedStyle = {
  backgroundColor: '#FF0000',
  color: '#FFFFFF'
};

const styleArticle22 = {
  backgroundColor: '#FFA07A',
  color: '#515151'
};

const styleNotWorking = {
  backgroundColor: '#F3C342',
  color: '#515151'
};

const styleHasReplaced = {
  backgroundColor: '#B0E0E6',
  color: '#515151'
};

const tableHeader = () => {
  return [
    'Fecha',
    'Jornada Pactada',
    'Marcaciones Jornada',
    'Colación',
    'Marcaciones Colación',
    'Tiempo Faltante',
    'Tiempo Extra',
    'Otras Marcaciones',
    'Observaciones',
    'Autorización Jornada'
  ];
};

const appendValueIfPresent = (value, append) => {
  return value.length > 0 ? `${append} ${value}` : value;
};

const renderResult = (isArticle22, attendance, employeeId) => {
  let styles = null;
  if (attendance.non_working_day_assis) {
    styles = styleNotWorking;
  }
  if (attendance.attendance_incomplete) {
    styles = selectedStyle;
  }
  if (isArticle22) {
    styles = styleArticle22;
  }
  if (attendance.has_replaced || (employeeId === 2570 && attendance.date_formatted === '17/05/23')) {
    styles = styleHasReplaced;
  }

  const renderObservation = observation => (
    <div dangerouslySetInnerHTML={{ __html: observation.replace(/\n/g, '<br>') }} />
  );

  const renderAttendnaceActivities = activities => (
    <div dangerouslySetInnerHTML={{ __html: activities.replace(/\n/g, '<br>') }} />
  );

  return (
    <tr style={styles}>
      <td className="text-center align-middle">{attendance.date_formatted}</td>
      <td className="text-center align-middle">{attendance.shift}</td>
      <td className="text-center align-middle">{attendance.attendance_day}</td>
      <td className="text-center align-middle">{attendance.shift_break}</td>
      <td className="text-center align-middle">{attendance.attendance_break}</td>
      {
        <td
          className="text-center align-middle"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              attendance.anomalies
                ? attendance.anomalies
                    .split('<br>')
                    .filter(t => t.trim() !== '')
                    .map(time => `- ${time}`)
                    .join('<br>')
                : ''
            )
          }}
        />
      }
      <td className="text-center align-middle">{appendValueIfPresent(attendance.hours_extra, '+')}</td>
      <td className="text-center align-middle">{renderAttendnaceActivities(attendance.attendnace_activities)}</td>
      <td className="text-center align-middle">
        {attendance?.document && <>Pacto de Horas Extra</>}
        {renderObservation(attendance.observation)}
      </td>
      <td className="text-center align-middle">{attendance.exeptional_workday_number}</td>
    </tr>
  );
};

const WorkdayReportToPrint = React.forwardRef(({ data }, ref) => {
  const { getEmployeeInfo, getCompanyInfo } = PrintFunctions();

  return (
    <div
      className="table_to_print print_report"
      ref={ref}
      style={{
        margin: '0 auto',
        maxWidth: '800px',
        padding: '20px'
      }}
    >
      {data.length > 0 && (
        <>
          {data.map(employee => (
            <div
              key={employee.employee_id}
              className="employee-report-container"
              style={{ pageBreakInside: 'avoid', marginBottom: '30px' }}
            >
              <p>Reporte de Jornada Diaria</p>
              {getCompanyInfo(employee)}
              {getEmployeeInfo(employee)}
              <p>
                <br />
              </p>
              <table className="table-print table-sm table-bordered">
                <tbody>
                  <tr style={{ backgroundColor: '#EBEBEB' }}>
                    {tableHeader().map(itemHeader => (
                      <th className="text-center align-middle" key={itemHeader}>
                        {itemHeader}
                      </th>
                    ))}
                  </tr>
                  {employee.attendances.map((attendance, idx) => (
                    <React.Fragment key={attendance.attendances[0]?.date_formatted || idx}>
                      {attendance.attendances.map(attendances =>
                        renderResult(employee.is_article_22, attendances, employee.employee_id)
                      )}
                      <tr style={{ backgroundColor: '#EBEBEB' }}>
                        <td className="text-center align-middle"> Totales Semanales </td>
                        <td className="text-center align-middle"> {attendance.total_times[0].parsed_shift_time} </td>
                        <td className="text-center align-middle">
                          {attendance.total_times[0].parsed_attendance_day_t}
                        </td>
                        <td className="text-center align-middle">
                          {attendance.total_times[0].parsed_shift_break_time}
                        </td>
                        <td className="text-center align-middle"> {attendance.total_times[0].p_attendance_break_t} </td>
                        <td className="text-center align-middle">
                          {' '}
                          {appendValueIfPresent(attendance.total_times[0].p_anomalies_time, '-')}{' '}
                        </td>
                        <td className="text-center align-middle">
                          {' '}
                          {appendValueIfPresent(attendance.total_times[0].p_hours_extra_time, '+')}{' '}
                        </td>
                        <td className="text-center align-middle">&nbsp;</td>
                        <td className="text-center align-middle">
                          Compensación: {attendance.total_times[0].compensation}
                        </td>
                        <td className="text-center align-middle">&nbsp;</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </>
      )}
    </div>
  );
});

export default WorkdayReportToPrint;
